export const systemDe = {
  // LegalPage
  'system.legal.fallbackTitle': 'Dokument',
  'system.legal.fallbackBody': 'Nicht gefunden.',
  'system.legal.lastUpdated': 'Zuletzt aktualisiert {date}',

  // NotFoundPage
  'system.notFound.seoTitle': 'Verloren im Schleier',
  'system.notFound.heading': 'Du bist über den Rand der Karte hinausgewandert',
  'system.notFound.body': 'Der Pfad, den du gesucht hast, wurde vom ewigen Zwielicht verschlungen.',
  'system.notFound.returnCta': 'Zurück zum Schleier',

  // RouteErrorBoundary
  'system.error.unknownDisturbance': 'Eine unbekannte Störung erschütterte den Schleier.',
  'system.error.seoTitle': 'Eine Störung im Schleier',
  'system.error.heading': 'Das Ritual stockte',
  'system.error.body':
    'Etwas Unsichtbares hat diese Seite gestört. Der Schleier ist hier dünn — versuche es erneut oder kehre auf sichereren Boden zurück.',
  'system.error.tryAgain': 'Erneut versuchen',
  'system.error.returnCta': 'Zurück zum Schleier',
  'licenseGate.heading': "Demnächst — lizenzrechtlich eingeschränkt",
  'licenseGate.body': "Diese Sprachausgabe ist aus Lizenzgründen noch nicht verfügbar. Sie ist in Arbeit — schau bald wieder vorbei.",
} as const
